// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"0723bb35","187":"0723bb35"}[chunkId] + ".css";
};